import { createSlice } from "@reduxjs/toolkit";
import { editCustomerAPI } from "../../api/customer";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const editCustomerSlice = createSlice({
  name: "editCustomer",
  initialState: data,
  reducers: {
   editCustomerSlice(state) {
      state.isLoading = true;
    },
   editCustomerSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editCustomerSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    editCustomerSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const editCustomerHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(editCustomerAction.editCustomerSlice());
    const response: any = await editCustomerAPI(id,data);
    
    dispatch(editCustomerAction.editCustomerSliceSuccess(response));
  } catch (e: any) {
    dispatch(editCustomerAction.editCustomerSliceFailure(e?.response?.data));
  }
};
export default editCustomerSlice.reducer;
export const editCustomerAction = editCustomerSlice.actions;
